// src/components/sections/HeroCarousel/index.js
import HeroCarousel from './HeroCarousel';
export default HeroCarousel;